import React from 'react';
import normalizeWheel from 'normalize-wheel';

interface INormalizedWheelEventValues {
    spinX: number;
    spinY: number;
    pixelX: number;
    pixelY: number;
}

export const createHeaderScrollHandler = (scrollerRef: any) => (ev: React.WheelEvent<HTMLElement>) => {
    const normalizedValues = normalizeWheel(ev) as INormalizedWheelEventValues;
    const currentScrollTop = scrollerRef.scrollTop ? scrollerRef.scrollTop : 0;
    // eslint-disable-next-line no-unused-expressions
    scrollerRef.scrollTo && scrollerRef.scrollTo(0, currentScrollTop + normalizedValues.pixelY);
};

export const scrollToTop = () => {
    if (window.scrollTo) {
        window.scrollTo(0, 0);
    }
};
